import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-src"]
const _hoisted_2 = { class: "ds-gdpr-overlay__content-inner" }
const _hoisted_3 = { class: "ds-gdpr-overlay__title" }
const _hoisted_4 = { class: "ds-gdpr-overlay__text" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "ds-gdpr-overlay__actions" }

import { ref, onMounted } from "vue";
import DsButton from "../button/ds-button.vue";
import { useWecomaIntegration } from "@sazka/utils/gdpr/use-wecoma-integration";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";
import { useWebpBackgroundImage } from "@sazka/utils/webp-background-images";
import { WecomaConstants } from "@sazka/utils/gdpr/wecoma-constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-modal-video-gdpr-overlay',
  props: {
    videoUrl: {}
  },
  setup(__props: any, { expose: __expose }) {

/* eslint-disable @nx/enforce-module-boundaries */
const { header, message, button, link, linkUrl, bg } = environment.gdprOverlay;
const preferenceCenterLinkUrl = `${appSettings["Integrations:Wecoma:Domain"]}?key=${WecomaConstants.WECOMA_CODE_DEH}&locale=cs-CZ&authKeys=${WecomaConstants.WECOMA_AUTHKEY}&source=thirdpartycontent`;
const linkUrlCombined = linkUrl || preferenceCenterLinkUrl;
const gdprOverlay = ref<HTMLElement | null>(null);
const gdprOverlayContent = ref<HTMLElement | null>(null);

const { consentToThirdParty } = useWecomaIntegration();

const consent = async () => {
    await consentToThirdParty();
    eventBus.emit(GlobalEvents.ConsentsChanged);
};

onMounted(() => {
    gdprOverlay.value.style.minHeight = `calc(${gdprOverlay.value.scrollHeight}px + calc(var(--sp-dynamic-300, 24px) * 2))`;

    useWebpBackgroundImage(gdprOverlay.value);
});



__expose({
    gdprOverlayContent,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ds-gdpr-overlay",
    "data-src": _unref(bg),
    ref_key: "gdprOverlay",
    ref: gdprOverlay
  }, [
    _createElementVNode("div", {
      class: "ds-gdpr-overlay__content",
      ref_key: "gdprOverlayContent",
      ref: gdprOverlayContent
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(header)), 1),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("span", { innerHTML: _unref(message) }, null, 8, _hoisted_5),
          (_ctx.videoUrl)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _cache[1] || (_cache[1] = _createTextVNode(" Video můžete zhlédnout přímo na webové stránce poskytovatele ")),
                _createElementVNode("a", {
                  href: _ctx.videoUrl,
                  target: "_blank",
                  rel: "noreferrer"
                }, _cache[0] || (_cache[0] = [
                  _createElementVNode("strong", null, "zde", -1)
                ]), 8, _hoisted_7),
                _cache[2] || (_cache[2] = _createTextVNode(". "))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(DsButton, {
          type: "primary",
          theme: "dark",
          onClick: consent
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(button)), 1)
          ]),
          _: 1
        }),
        _createVNode(DsButton, {
          type: "secondary",
          href: _unref(linkUrlCombined),
          "is-external": ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(link)), 1)
          ]),
          _: 1
        }, 8, ["href"])
      ])
    ], 512)
  ], 8, _hoisted_1))
}
}

})